const STORAGE_KEY = 'globalFilter';

export function getGlobalFilter(key?: string) {
  const storedData = JSON.parse(localStorage.getItem(STORAGE_KEY));

  if (!key || !storedData) {
    return storedData;
  }

  if (!storedData || !storedData.hasOwnProperty(key)) {
    return null;
  }

  return storedData[key];
}

export function storeGlobalFilterData(newState, key?: string, filterKey?: string) {
  if (!newState) {
    return;
  }

  if (!key) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
    return;
  }

  let storedData = JSON.parse(localStorage.getItem(STORAGE_KEY));

  if (!storedData) {
    storedData = {};
  }

  if (filterKey) {
    newState = {
      [filterKey]: [...newState],
    };
  }

  storedData[key] = {
    ...storedData[key],
    ...newState,
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(storedData));
}
